module.exports = __webpack_public_path__ + "img/84.6a3d6d3c.jpg";